export const ACCOUNT_BASE_PATH = '/minha-conta'

/**
 * Caminhos da área "Minha conta".
 *
 * Moram em `shared/lib/routing` e não na feature porque o chrome do app também
 * depende deles — `Layout` esconde TopBar e BottomNav no editor de avatar, e o
 * menu lateral aponta para as seções. `shared/` não pode importar de
 * `features/`, então a rota é o que sobe, não o consumidor que desce.
 */
export const ACCOUNT_PATHS = {
  profile: `${ACCOUNT_BASE_PATH}/perfil`,
  networking: `${ACCOUNT_BASE_PATH}/networking`,
  security: `${ACCOUNT_BASE_PATH}/seguranca`,
  privacy: `${ACCOUNT_BASE_PATH}/privacidade`,
  development: `${ACCOUNT_BASE_PATH}/desenvolvimento`,
  avatar: `${ACCOUNT_BASE_PATH}/avatar`
} as const

/**
 * O editor de avatar roda em tela cheia: no mobile o `Layout` suprime TopBar e
 * BottomNav enquanto esta rota está ativa.
 */
export const isAvatarEditorRoute = (pathname: string): boolean =>
  pathname.includes(ACCOUNT_PATHS.avatar)
